import { Galeria as c } from "../EditPanel/Galeria";
import { conLanding } from "../Models/Landing";

export default class Galeria extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}